import phoneIcon from "../../assets/images/phon.png";
import emailIcon from "../../assets/images/email-ico.png";
import siteIcon from "../../assets/images/site-ico.png";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { useRef, useState, useReducer } from "react";
import CommonMethods from "../../common/CommonMethods";

function ContactUs() {
  const reducer = (state: any, action: any) => {
    if (action.type == "showDialog") {
      return { ...state, show: action.payload };
    }
    if (action.type == "setName") {
      return { ...state, name: action.payload };
    }
    if (action.type == "setEmail") {
      return { ...state, email: action.payload };
    }
    if (action.type == "setMessage") {
      return { ...state, message: action.payload };
    }
    if (action.type == "reset") {
      return { ...state, name: "", email: "", message: "" };
    }
    return state;
  };
  const [state, dispatch] = useReducer(reducer, {
    show: false,
    name: "",
    email: "",
    message: "",
  });
  // const [show, setShow] = useState(false);
  // const [name, setName] = useState("");
  // const [email, setEmail] = useState("");
  // const [message, setMessage] = useState("");

  var inputName = useRef(null);
  var inputEmail = useRef(null);
  var inputMessage = useRef(null);

  const handleClose = () => dispatch({ type: "showDialog", payload: false }); //setShow(false);
  const handleShow = () => dispatch({ type: "showDialog", payload: true }); //setShow(true);

  const submitData = () => {
    (inputName!.current as any)!.className = "form-control";
    (inputEmail!.current as any)!.className = "form-control";
    (inputMessage!.current as any)!.className = "form-control";
    if (!state.name) {
      (inputName!.current as any)!.className = "form-control requiredField";
    }
    if (!state.email) {
      (inputEmail!.current as any)!.className = "form-control requiredField";
    }
    var postObj = {
      name: state.name,
      email: state.email,
      message: state.message,
    };
    console.log(postObj);
    if (state.name && state.email) {
      CommonMethods.sendMessage(postObj)
        .then((res: any) => {
          dispatch({ type: "showDialog", payload: true });
          dispatch({ type: "reset", payload: true });
          // setShow(true);
          // setName("");
          // setMessage("");
          // setEmail("");
        })
        .catch((err: any) => {});
    }
  };

  return (
    <>
      <section className="product-wrap cont-form">
        <div className="container">
          <div className="row height-cont">
            <h1
              style={{
                color: "#4348bd",
                textAlign: "left",
                fontSize: "40px",
                marginBottom: "30px",
              }}
            >
              Contact us
            </h1>
            <div className="row cont-white">
              <div
                className="cont-left col-sm-12 col-lg-6 "
                data-aos="fade-up"
                data-aos-delay="10"
              >
                <div className="cont-left-text">
                  <div className="row align-items-center text-center">
                    <div className="col-12 d-block">
                      <p>
                        {" "}
                        Our team is happy to assist you!. Please reach out to
                        us.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 ">
                    <span>
                      <img src={phoneIcon} alt="" />
                    </span>
                    +91-484-4607541 (India){" "}
                  </div>
                  <div className="col-12 email-left">
                    <span>
                      <img src={emailIcon} alt="" />
                    </span>
                    <a href="mailto:support@cloudlas.com">
                      support@cloudlas.com
                    </a>{" "}
                  </div>
                  <div className="col-12 ">
                    <span>
                      <img src={siteIcon} alt="" />
                    </span>
                    <span className="addrs">
                      Door No: 11 B&C, SFS Silicon Meadows, Kochi-682037,
                      <br />
                      Kerala, India{" "}
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="cont-right col-sm-12 col-lg-6 "
                data-aos="fade-up"
                data-aos-delay="10"
              >
                <div>
                  <div className="mb-3">
                    <label>
                      <span>Name</span>
                    </label>
                    <input
                      className="form-control"
                      ref={inputName}
                      maxLength={100}
                      name="name"
                      value={state.name}
                      onChange={(e) =>
                        dispatch({ type: "setName", payload: e.target.value })
                      } // setName(e.target.value)}
                      id="name"
                      type="text"
                      placeholder=""
                    />
                  </div>
                  <div className="mb-3">
                    <label>
                      <span>Email</span>
                    </label>
                    <input
                      className="form-control"
                      ref={inputEmail}
                      maxLength={100}
                      type="email"
                      value={state.email}
                      onChange={(e) =>
                        dispatch({ type: "setEmail", payload: e.target.value })
                      } // setName(e.target.value)}
                      name="email"
                      id="email"
                      required
                      placeholder=""
                    />
                  </div>
                  <div className="mb-3">
                    <label>
                      <span>Message</span>
                    </label>
                    <textarea
                      name="message"
                      ref={inputMessage}
                      maxLength={300}
                      value={state.message}
                      onChange={(e) =>
                        dispatch({
                          type: "setMessage",
                          payload: e.target.value,
                        })
                      } // setName(e.target.value)}
                      id="message"
                      placeholder=" "
                      className="form-control"
                    ></textarea>
                  </div>
                  <div className="col-auto text-end button">
                    <button
                      id="submit_btn4"
                      onClick={() => {
                        submitData();
                      }}
                      className="btn btn-primary px-4"
                    >
                      Send us a message
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal show={state.show} onHide={handleClose} className="contactUsPopup">
        <Modal.Header closeButton>
          <Modal.Title>Thanks for your message!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Our team will contact you soon</Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
}

export default ContactUs;
